import { httpService } from 'src/services/app/http.service'
import { localStorageService } from 'src/services/app/storage.service'
import { FCM_ENDPOINTS, STORAGE_KEYS } from 'src/services/consts/api.const'
import { log } from 'src/services/app/log.service'
import { APP_NAME } from 'src/services/consts/fcm.const'

export const fcmService = {
  async updateToken(token) {
    try {
      // Check if this token was already sent to backend (shared across tabs via localStorage)
      const cachedToken = localStorageService.getCachedData(STORAGE_KEYS.FCM_TOKEN_CACHE)
      if (cachedToken === token) {
        log.info('[FCM] Token unchanged, skipping backend update')
        return { cached: true, token }
      }

      // Token has changed or is new - send to backend
      const response = await httpService.post(FCM_ENDPOINTS.UPDATE_TOKEN, {
        token,
        app: APP_NAME,
      })

      // Cache the token after successful update (shared across all tabs)
      localStorageService.cacheData(STORAGE_KEYS.FCM_TOKEN_CACHE, token, 1000 * 60 * 60 * 24 * 7) // 7 days
      log.info('[FCM] ✅ Token sent and cached to localStorage')

      return response
    } catch (err) {
      log.error('[FCM] ❌ Error:', err)
      throw new Error(`Backend error: ${err.message || 'Failed to save token'}`)
    }
  },

  clearTokenCache() {
    localStorageService.remove(STORAGE_KEYS.FCM_TOKEN_CACHE)
    log.info('[FCM] Token cache cleared')
  },
}
